var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    height: 20,
    width: 20,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M10,18.5c-4.687,0-8.5-3.812-8.5-8.5S5.313,1.5,10,1.5c4.687,0,8.5,3.813,8.5,8.5    S14.687,18.5,10,18.5z M10,2.5c-4.136,0-7.5,3.364-7.5,7.5c0,4.135,3.364,7.5,7.5,7.5s7.5-3.364,7.5-7.5    C17.5,5.864,14.136,2.5,10,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M10.062,15.422c-0.276,0-0.5-0.224-0.5-0.5V8.328c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5    v6.593C10.562,15.198,10.339,15.422,10.062,15.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M10,7.286c-0.747,0-1.354-0.607-1.354-1.354S9.253,4.578,10,4.578s1.354,0.607,1.354,1.354    S10.747,7.286,10,7.286z M10,5.578c-0.195,0-0.354,0.159-0.354,0.354S9.805,6.286,10,6.286s0.354-0.159,0.354-0.354    S10.195,5.578,10,5.578z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInformation);
export default __webpack_public_path__ + "static/media/more-information.8354a43ddcd64205524c2928a5ef9390.svg";
export { ForwardRef as ReactComponent };